import {ReportHandler} from 'web-vitals';
/*
Web Vitals is an initiative by Google to provide unified guidance for quality 
that are essential to delivering a great user experience on the web.
*/
const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);//get Cumulative Layout Shift 
      getFID(onPerfEntry);//get First Input Delay
      getFCP(onPerfEntry);//get First Contentful Paint (FCP)
      getLCP(onPerfEntry);//get Largest Contentful Paint (LCP)
      getTTFB(onPerfEntry);//get Time to First Byte (TTFB)
    });
  }
};

export default reportWebVitals;
